module.exports = __webpack_public_path__ + "sx6-744708ff.png";